var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheckBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    fill: "#00AB58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 24.1701L12.8302 20.0001L11.4102 21.4101L17.0002 27.0001L29.0002 15.0001L27.5902 13.5901L17.0002 24.1701Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#525F6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckBox);
export default __webpack_public_path__ + "static/media/green-check-box.36ef848b64131f1b617c52495167a48f.svg";
export { ForwardRef as ReactComponent };